import { EventEmitter } from "../../utils/EventEmitter";
export const ITutorialEvents = new EventEmitter<[]>();
